import { Card, Icon, Text } from '@/components'
import InfoCard from '@/app/components/InfoCard/InfoCard'
import { useNavigation } from '@/app/hooks'

export default function NotificationsCard() {
  const { push: navigateTo } = useNavigation()

  return (
    <Card>
      <div className="flex gap-2 mb-5">
        <Text variant="subheader">Notifications</Text>
      </div>

      <InfoCard
        title="Push notifications"
        onClick={() => navigateTo('/settings/push-notifications')}
        variant="small"
        image={
          <Icon
            name="Bell"
            className={'w-5 h-5 mr-3 flex items-center text-themed-grey-500'}
          />
        }
      />
    </Card>
  )
}
